import React from "react";

export default function TextWidget({ html_content }: { html_content: string }) {
  return (
    <div
      className="widget text-widget p-4 overflow-auto"
      style={{ wordBreak: "break-word" }}
      dangerouslySetInnerHTML={{ __html: html_content }}
    />
  );
}
